// extracted by mini-css-extract-plugin
module.exports = {"sticky":"BottomPanel_sticky__jTSU7"};